import { useModal } from '@hrms/common/contexts/modal';
import { Typography } from '@zeptonow/zui';
import { useCallback } from 'react';
import UserPreferenceModalAction from '../components/UserPreferenceModalAction';
import UserPreferenceModalContent from '../components/UserPreferenceModalContent';
import { preferenceStore } from '../store';
import { generateImage } from '@hrms/common/utils/generateImage';

const useUserPreferenceModal = () => {
  const { showModal, hideModal } = useModal();
  const { preference } = preferenceStore();

  const openUserPreferenceModal = useCallback(
    ({ showCancelBtn = false }: { showCancelBtn?: boolean }) => {
      showModal({
        disableBackdropClick: !showCancelBtn,
        title: (
          <div className="flex flex-col">
            <div className="self-center">
              {generateImage({
                name: 'organization',
                alt: 'org icon',
                className: 'w-16 h-16',
              })}
            </div>
            <Typography variant="h6" className="!text-gray-900" align="center">
              User Preferences
            </Typography>
          </div>
        ),
        description: <UserPreferenceModalContent />,
        actionButton: (
          <UserPreferenceModalAction showCancelBtn={showCancelBtn} />
        ),
        hideCrossIcon: true,
        initialData: preference,
      });
    },
    [preference],
  );

  const closeUserPreferenceModal = useCallback(() => {
    hideModal();
  }, []);

  return {
    openUserPreferenceModal,
    closeUserPreferenceModal,
  };
};

export default useUserPreferenceModal;
